require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/fn/regexp/escape.js
// module id = 258
// module chunks = 0